<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsVideo',
  
})
</script>
<template>
  <div class="tlbs-video">
    <video
      ref="videoPlayer"
      class="video-js vjs-big-play-centered vjs-fluid"
    />
  </div>
</template>

<script lang="ts" setup name="TlbsVideo">
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

interface Props {
  src: string;
  poster?: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  src: '',
  poster: '',
  autoplay: false,
  loop: false,
  muted: false,
  controls: true,
});

const Mimetypes = {
  opus: 'video/ogg',
  ogv: 'video/ogg',
  mp4: 'video/mp4',
  mov: 'video/mp4',
  m4v: 'video/mp4',
  mkv: 'video/x-matroska',
  m4a: 'audio/mp4',
  mp3: 'audio/mpeg',
  aac: 'audio/aac',
  caf: 'audio/x-caf',
  flac: 'audio/flac',
  oga: 'audio/ogg',
  wav: 'audio/wav',
  m3u8: 'application/x-mpegURL',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  png: 'image/png',
  svg: 'image/svg+xml',
  webp: 'image/webp',
};
const videoPlayer = ref<Element | null>(null);
let player: videojs.Player;

const videoType = computed(() => props.src?.substring(props.src.lastIndexOf('.') + 1).toLowerCase());
const options = ref({
  sources: [
    {
      src: props.src || 'no',
      type: Mimetypes[videoType.value] || 'video/mp4',
    },
  ],
  language: 'zh-CN', // 设置语言
  poster: props.poster,
  autoplay: props.autoplay,
  loop: props.loop,
  muted: props.muted,
  controls: props.controls,
  controlBar: {
    children: [
      { name: 'playToggle' }, // 底部暂停按钮
      { name: 'currentTimeDisplay' }, // 当前已播放时间
      { name: 'progressControl' }, // 进度条
      { name: 'durationDisplay' }, // 总时间
      {
        name: 'volumePanel', // 音量控制
        inline: false, // 不使用水平方式
      },
      { name: 'FullscreenToggle' }, // 全屏按钮
    ],
  },
});

watch(() => props.src, (newSrc) => {
  player.src([
    {
      src: newSrc,
      type: Mimetypes[videoType.value],
    },
  ]);
  player.load();
});
watch(() => props.poster, newVal => player.poster(newVal));
watch(() => props.autoplay, newVal => player.autoplay(newVal));
watch(() => props.loop, newVal => player.loop(newVal));
watch(() => props.muted, newVal => player.muted(newVal));
watch(() => props.controls, newVal => player.controls(newVal));

onMounted(() => {
  if (!videoPlayer.value) return;
  console.log(options.value);
  player = videojs(videoPlayer.value, options.value);
});

onBeforeUnmount(() => {
  player?.dispose();
});
</script>
